import { config } from '../config';

export async function post<T>(endpoint: string, body: object = {}): Promise<T | null> {
    try {
        const response = await fetch(`${config.serverBaseUrl}${endpoint}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });

        if (!response.ok) {
            console.error(`Failed to fetch from ${endpoint}:`, response.statusText);
            return null;
        }

        return await response.json() as T;
    } catch (error) {
        console.error(`Error fetching from ${endpoint}:`, error);
        return null;
    }
}
